// Loaded by the CSS entries via @config. v4 moved several concerns out of
// this file into the entry CSS: prefix (`prefix(tw)` on the imports),
// darkMode and vertical breakpoints (@custom-variant), preflight (simply
// not imported), container centering and custom utilities (@utility).
module.exports = {
  content: [
    './assets/**/*.js',
    './assets/**/*.vue',
    './src/**/*.twig',
    './src/Vacatia/AdminBundle/Resources/**/*.twig',
    './src/Vacatia/CoreBundle/Resources/**/*.twig',
    './src/Vacatia/RentalBundle/Resources/**/*.twig',
    './templates/**/*.twig',
    './node6/assets/js/rental-es6/**/*.js',
  ],
  theme: {
    // New names here (colors and keyframes aside) must also go in
    // App\Twig\TailwindMergeExtension::CONFIGURATION.
    extend: {
      boxShadow: {
        // Vroom Vroom card shadow — matches Figma (Parkway, ENG-374)
        'vroomvroom-card': '0px 10px 7.5px rgba(0, 0, 0, 0.1), 0px 4px 3px rgba(0, 0, 0, 0.1)',
      },
      letterSpacing: {
        hyper: '.15rem',
      },
      backgroundPosition: {
        'pos-center-bottom': 'center bottom',
        'pos-subscribe-section': 'calc(50% - 1rem) bottom',
        'pos-md-subscribe-section': 'calc(50% - 26rem) bottom',
        'pos-subscribe-hero': 'calc(50% - 1rem) bottom',
        'pos-md-subscribe-hero': 'calc(50% - 22rem) bottom',
      },
      backgroundSize: {
        'size-subscribe-section': 'auto 9.9375rem',
        'size-md-subscribe-section': 'auto 21.6875rem',
        'size-subscribe-hero': '35rem auto',
        'size-md-subscribe-hero': 'auto 21.625rem',
        'size-where-can-i-go-section': 'auto 8rem',
        'size-md-where-can-i-go-section': 'auto',
        'size-auth-modal': '100% auto',
        'size-md-auth-modal': '154% auto',
      },
      colors: {
        'vacatia-blue': {
          DEFAULT: '#2e95ec',
          light: '#499ef1',
          lighter: '#d5eafb',
          lighterer: '#e0effc',
          lightest: '#eaf4fd',
          dark: '#1e3a5f',
        },
        'vacatia-orange': {
          DEFAULT: '#ed6f2d',
          light: '#F0612F',
          dark: '#f1612f',
        },
        'vacatia-green': {
          light: '#66cc66',
          dark: '#369336',
        },
        'vacatia-plus': {
          DEFAULT: '#1c3c9b'
        },
        'owner': {
          blue: '#0D3B66',
          cream: '#E9E9DB',
          coral: '#FA8072',
          error: '#cc0000',
        },
        'closed-user-group': {
          primary: '#2e95ec', // same as vacatia-blue.DEFAULT
          secondary: '#0D3B66', // same as owner.blue
          tertiary: '#A7D8F5',
          accent: '#FE615E',
          bg: '#ffffff',
          'bg-neutral': '#f5f5f5', // same as f5
          text: '#333333', // same as 333
        },
        'vroomvroom': {
          'border-light': '#E0F2FE',
          'border-warning': '#FE615E',
          'border-info': '#2E95EC',
          'border-separator': '#D5D5D5',
          'departure-bg': '#F0FDF4',
          'departure-border': '#B9F8CF',
          'departure-text': '#0D542B',
          'return-bg': '#EFF6FF',
          'return-border': '#BEDBFF',
          'return-text': '#1C398E',
        },
        // Design System v2 tokens, keyed by their Figma paths: docs/design-system.md
        'ds': {
          text: {
            default: '#333333',
            muted: '#4a4a4a',
            disabled: '#afafaf',
          },
          bg: {
            subtle: '#f5f5f5',
          },
          border: {
            default: '#d0d0d0',
          },
          feedback: {
            'success-bg': '#eaf7f1',
            'success-text': '#0e4530',
          },
        },

        'error-red': '#f72600',
        'f1': '#f1f1f1',
        'f2': '#f2f2f2',
        'f5': '#f5f5f5',
        'eee': '#eeeeee',
        'e6': '#e6e6e6',
        'd5': '#d5d5d5',
        'ccc': '#cccccc',
        '999': '#999999',
        '666': '#666666',
        '333': '#333333',
        '093': '#009933',
        'c30': '#CC3300',

        // Accessible Palettes
        // Blue (Primary)
        'a11y-blue': {
          50: '#F7FAFF',
          100: '#E1F0FD',
          200: '#B5DAF7',
          300: '#87C4F3',
          400: '#58ACEE',
          500: '#2C92E1',
          600: '#2478B8',
          700: '#1F639B',
          800: '#18507A',
          900: '#133F60',
          950: '#091D2E',
        },
        // Green (Success)
        'a11y-green': {
          50: '#F7FBF5',
          100: '#E3F2DF',
          200: '#BEDDAD',
          300: '#97C97E',
          400: '#70B44D',
          500: '#439D1E',
          600: '#318211',
          700: '#286C0C',
          800: '#205608',
          900: '#194405',
          950: '#0B2000',
        },
        // Yellow (Warning)
        'a11y-yellow': {
          50: '#FFFAE7',
          100: '#FFECAB',
          200: '#FFCD2C',
          300: '#E4B422',
          400: '#C79E1B',
          500: '#A98416',
          600: '#8A6F10',
          700: '#745B0C',
          800: '#5B4807',
          900: '#483905',
          950: '#221B00',
        },
        // Red (error)
        'a11y-red': {
          50: '#FEF9F9',
          100: '#FDE9E9',
          200: '#F5CACA',
          300: '#F0AAAA',
          400: '#EB8888',
          500: '#E45E60',
          600: '#DC252B',
          700: '#B81E23',
          800: '#92181B',
          900: '#751315',
          950: '#3A0A0A',
        },
        // Neutral
        'a11y-neutral': {
          50: '#FAFAFA',
          100: '#EDEDED',
          200: '#D4D5D4',
          300: '#BDBCBC',
          400: '#A4A4A4',
          500: '#8B8B8B',
          600: '#727272',
          700: '#5F5F5F',
          800: '#4B4B4B',
          900: '#3B3B3A',
          950: '#1B1B1B',
        },
      },
      flex: {
        '2': '2 2 0%',
        '3': '3 3 0%',
        '4': '4 4 0%',
        '5': '5 5 0%',
        '6': '6 6 0%',
        '7': '7 7 0%',
        '8': '8 8 0%',
        '9': '9 9 0%',
        '10': '10 10 0%',
        '11': '11 11 0%',
        '12': '12 12 0%',
      },
      fontFamily: {
        sans: '"Montserrat", Helvetica, Arial, sans-serif',
        'sans-legacy': '"Open Sans", Helvetica, Arial, sans-serif',
      },
      fontSize: {
        'xxs': '0.625rem',
        '15': '0.9375rem',
      },
      keyframes: {
        wave: {
          '0%, 60%, 100%': { transform: 'rotate(0deg)' },
          '10%, 30%, 50%': { transform: 'rotate(14deg)' },
          '20%, 40%': { transform: 'rotate(-8deg)' },
        },
      },
      animation: {
        wave: 'wave 1.6s ease-in-out 1',
      },
      lineHeight: {
         '16': '4rem',
      },
      width: {
        'xxs': '360px',
        'xs': '414px',
        'sm': '640px',
        'md': '768px',
        'lg': '1024px',
        'xl': '1280px',
        '2xl': '1536px',
      },
    },
    screens: {
      'xxs': '360px',
      'xs': '414px',
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1536px',
      '3xl': '1680px',
    },
  },
}
